import { Line } from '@ant-design/plots'
import { Empty } from 'antd'
import dayjs from 'dayjs'

const groupDataByMonth = (data) => {
  const result = {}

  data.forEach(({ date, count }) => {
    const monthKey = dayjs(date).format('YYYY-MM')
    result[monthKey] = (result[monthKey] || 0) + count
  })

  return Object.entries(result)
    .sort(([a], [b]) => dayjs(a).unix() - dayjs(b).unix())
    .map(([monthKey, count]) => ({
      date: dayjs(monthKey, 'YYYY-MM').format('MMM YY'),
      count,
    }))
}

const DailyChatChart = ({
  data,
  theme = 'classicDark',
  chartHeight = 200,
  chartWidth = 200,
}) => {
  const dailyData = data?.dailyChats ?? []

  if (dailyData.length === 0) {
    return (
      <div
        style={{
          height: chartHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Empty description="No data available" />
      </div>
    )
  }
  dailyData.sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix())

  const displayData =
    dailyData.length > 50 ? groupDataByMonth(dailyData) : dailyData
  const isMonthly = dailyData.length > 50

  const config = {
    theme,
    data: displayData,
    xField: 'date',
    yField: 'count',
    height: chartHeight,
    width: chartWidth,
    shapeField: 'smooth',
    scale: {
      y: {
        domainMin: 0,
      },
    },
    axis: {
      y: { title: 'Total No. of Chats', grid: null },
      x: {
        grid: null,
      },
    },
    xAxis: {
      title: {
        text: 'Chat Count',
        fill: '#FFFFFF',
      },
      style: {
        fill: '#FFFFFF',
        fontSize: 12,
      },
      label: {
        autoRotate: true,
        formatter: (val) => (isMonthly ? val : dayjs(val).format('DD MMM')),
      },
      tickCount: isMonthly ? undefined : 7,
    },
    interaction: {
      tooltip: {
        marker: false,
      },
    },
    style: {
      lineWidth: 2,
    },
  }

  return <Line {...config} />
}

export default DailyChatChart
